// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueJsonp from 'vue-jsonp'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
// import weui from 'weui.js'
// import 'weui'
// Vue.prototype.$weui = weui

// 公共样式
import "./assets/public.css"
// import 'vue-draggable-resizable.css'
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
// 加载工具类方法



/////////////////////
import { Rate } from 'vant';
import 'vant//lib/rate/style';
Vue.use(Rate);


import { Uploader } from 'vant';
Vue.use(Uploader);
import 'vant/lib/uploader/style'

import { RadioGroup, Radio } from 'vant';
import 'vant/lib/radio-group/style'
import 'vant/lib/radio/style'
Vue.use(RadioGroup);
Vue.use(Radio);
// import 'vant/lib/uploader/style'

import {Picker} from 'vant';
import 'vant/lib/picker/style';
import 'vant/lib/stepper/style';
Vue.use(Picker);

import { Stepper } from 'vant';

Vue.use(Stepper);

import { Divider } from 'vant';
import 'vant/lib/divider/style'

Vue.use(Divider);
/////////////////
import * as config from "./api/config"
import "./api/api"


// import Left from "./components/sidebar/left"
import Upper from "./components/sidebar/upper"
import Loginwarn from "./components/sidebar/loginwarn"
import IntroGoods from "./components/sidebar/intro-goods"
import GoodsList from "./components/sidebar/goods-list"


// import Pagination from "./components/sidebar/pagination"

Vue.use(ElementUI)
Vue.use(VueJsonp)
// 注册全局方法
Vue.prototype.$http = axios
Vue.config.productionTip = false



//配置项目访问路径
Vue.prototype.$imgBaseUrl=config.imgBSUrl;
Vue.prototype.$baseUrl=config.baseUrl;
// 注册全局组件
// Vue.component("Left",Left)
Vue.component("Upper",Upper)
Vue.component("Loginwarn",Loginwarn)
Vue.component("IntroGoods",IntroGoods)
Vue.component("GoodsList",GoodsList)


// Vue.component("Pagination",Pagination)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js